var map = {
	"./daily/baobao.jpg": 772,
	"./daily/motou.jpg": 7146,
	"./daily/shouji.jpg": 3834,
	"./daily/shuijiao.jpg": 6336,
	"./daily/tietie.jpg": 2300,
	"./drink/cha.jpg": 7437,
	"./drink/dao.jpg": 39,
	"./drink/dian.jpg": 1683,
	"./drink/hu.jpg": 7214,
	"./drink/ming.jpg": 3288,
	"./drink/nai.jpg": 4727,
	"./drink/rui.jpg": 2639,
	"./drink/xue.jpg": 1709,
	"./main/chaofan.jpg": 4524,
	"./main/danbaofan.jpg": 1592,
	"./main/hanbao.jpg": 639,
	"./main/huoguo.jpg": 5201,
	"./main/kaoya.jpg": 9781,
	"./main/miantiao.jpg": 3816,
	"./main/yu.jpg": 8108,
	"./play/changge.jpg": 5046,
	"./play/chuipaopao.jpg": 9034,
	"./play/chuolian.jpg": 1060,
	"./play/doufeng.jpg": 1891,
	"./play/fengzheng.jpg": 2553,
	"./play/gongyuan.jpg": 2181,
	"./play/guangjie.jpg": 5769,
	"./play/huahua.jpg": 9985,
	"./play/kanrichu.jpg": 7856,
	"./play/majiang.jpg": 2710,
	"./play/photo.jpg": 1785,
	"./play/shaitaiyang.jpg": 4085,
	"./play/tangzhe.jpg": 3682,
	"./play/wenquan.jpg": 8004,
	"./play/yecan.jpg": 4677,
	"./snack/binggan.jpg": 6867,
	"./snack/bingqiling.jpg": 3403,
	"./snack/buding.jpg": 2464,
	"./snack/dangao.jpg": 567,
	"./snack/maixuanfeng.jpg": 3402,
	"./snack/mianbao.jpg": 816,
	"./snack/shupian.jpg": 2813,
	"./snack/shutiao.jpg": 4868,
	"./spicy/hot.jpg": 6182,
	"./spicy/medium.jpg": 6634,
	"./spicy/mild.jpg": 7109
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1300;